import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { BeneficiaryVerifyOTP as BENE_VERIFY_OTP } from 'Components/Api/MahagramDMTAPI';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const BeneficiaryVerify = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const [severity, setSeverity] = useState('success');

    const location = useLocation();
    const Mobile = location.state.Mobile;
    const AccountNo = location.state.AccountNo;
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        AccountNo: AccountNo,
        OTP: ''
    });

    useEffect(() => {
        select();
    }, []);

    const select = async () => {
        setLoading(false);
        if (Mobile === undefined) {
            return;
        }

        setFormObject({
            ...formObject,
            Mobile: Mobile
        });
    };

    const submithandle = async (request, { setSubmitting, resetForm }) => {
        let jsonObj = {
            Mobile: request.Mobile,
            AccountNo: request.AccountNo,
            OTP: request.OTP
        };
        setIsError(false);
        setResponseMessage('');
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var verifyResponse = await BENE_VERIFY_OTP(apirequest);
        setLoading(false);

        if (!verifyResponse.isAuthorized) LOGOUT();

        if (!verifyResponse.status) {
            setSeverity('error');
            setResponseMessage(verifyResponse.data);
            setIsError(true);
            return;
        }

        setIsError(true);
        var data = JSON.parse(verifyResponse.data);

        setResponseMessage(data.Message);
        setSeverity('success');

        setIsError(true);
        var param = {
            Mobile: request.Mobile
        };

        history.push('/MG_SenderSearch', param);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'OTP')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Beneficiary Verify
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Mobile"
                                                name="Mobile"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                label="Account No."
                                                name="AccountNo"
                                                type="text"
                                                length={20}
                                                readOnly={true}
                                                placeholder="Account No."
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="OTP"
                                                name="OTP"
                                                type="text"
                                                length={6}
                                                placeholder="OTP"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Verify"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={(e) => {
                                                setFieldValue(
                                                    'isSecondSubmit',
                                                    false
                                                );
                                                handleSubmit(e);
                                            }}
                                            disabled={loading}
                                        >
                                            Verify OTP
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>

                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer>
    );
};
